import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import { SaveResult } from "../../models";
import { ErrorUserData } from "../../models/Error";

const apiUrlPrefix: string = "error-reporting";

export const sendErrorReport = async (errorUserData: ErrorUserData) => {
  return api.post(`${apiUrlPrefix}/send`, errorUserData) as Promise<
    SaveResult<ErrorUserData>
  >;
};
